export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12604.f952b804.jpg";